import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import React from "react";
import itemInfoStyles from "../../../assets/styles/components/itemInfoStyles";
import BreadCrumps from "../../../components/BreadCrups";
import SingleItemMenu from "../../../components/Menu/SingleItemMenu";
import NoContent from "../../../components/NoContent";
import { openLinkInNewTab } from "../../../helpers/helperMethods";

const styles = makeStyles((theme) => itemInfoStyles(theme));

export default (props) => {
  const { reportDetails, crumps } = props;

  const classes = styles();

  return (
    <div>
      <BreadCrumps crumps={crumps} />
      {reportDetails.title ? (
        <>
          <Grid container className={classes.topSection}>
            <Grid
              item
              xs={12}
              container
              direction="column"
              spacing={2}
              className={classes.infoSection}
              style={{
                marginLeft: 0,
              }}
            >
              <Grid item className={classes.textInfo}>
                <Typography variant="h4" className={classes.texts}>
                  {reportDetails.title}
                </Typography>

                <Grid item className={classes.actions}>
                  <Grid container spacing={2} justify="flex-end">
                    <SingleItemMenu
                      horiz
                      background
                      menu={props.actions}
                      item={reportDetails}
                    />
                  </Grid>
                </Grid>

                <Tooltip title="Author" placement="right-end" arrow>
                  <Typography variant="h6" className={classes.name}>
                    Author:{" "}
                    {reportDetails.author?.name || reportDetails.author?.id}
                  </Typography>
                </Tooltip>
                <Typography variant="body1" className={classes.texts}>
                  Status: {reportDetails.status}
                </Typography>
                <Typography variant="body1" className={classes.texts}>
                  Report Date: {reportDetails.date}
                </Typography>
                <Typography variant="body1" className={classes.texts}>
                  Created: {moment(reportDetails.createdAt).format("ll")}
                </Typography>
                <Typography
                  variant="body1"
                  className={classes.name}
                  onClick={() => openLinkInNewTab(reportDetails.pdfUrl)}
                >
                  View pdf..
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={12} container></Grid>
          </Grid>
          <Grid container className={classes.otherSections} direction="column">
            <Grid item>
              <Typography variant="h5" className={classes.title}>
                Summary
              </Typography>
            </Grid>

            <Grid
              item
              style={{
                width: "100%",
                wordWrap: "break-word",
              }}
            >
              <Typography variant="subtitle1">
                {reportDetails.summary}
              </Typography>
            </Grid>
          </Grid>
        </>
      ) : (
        <NoContent title="Unable to find Job" />
      )}
    </div>
  );
};
